export default {
  'title': '員工管理',
  'add': '添加員工',
  'list.username': '用戶名',
  'list.email': '郵箱',
  'list.role': '角色',
  'list.actions': '操作',
  'list.edit': '編輯',
  'list.delete': '刪除',
  'list.fetchFailed': '獲取員工列表失敗',
  'delete.confirm': '確認刪除',
  'delete.content': '確定要刪除此員工嗎？該操作不可撤銷。',
  'delete.success': '刪除成功',
  'delete.failed': '刪除失敗',
  'add.title': '添加員工',
  'edit.title': '編輯員工',
  'add.success': '添加成功',
  'add.failed': '添加失敗',
  'edit.success': '更新成功',
  'edit.failed': '更新失敗',
  'role.admin': '管理員',
  'role.staff': '員工',
  'tabs.basic': '基本信息',
  'tabs.permissions': '權限設置',
  'form.username': '用戶名',
  'form.username.required': '請輸入用戶名',
  'form.email': '郵箱',
  'form.email.required': '請輸入郵箱',
  'form.email.invalid': '郵箱格式不正確',
  'form.password': '密碼',
  'form.password.required': '請輸入密碼',
  'form.role': '角色',
  'form.role.required': '請選擇角色',
  'form.assignedStore': '分配門店',
  'form.permissionStore': '選擇權限門店',
  'form.permissionStore.placeholder': '請選擇要設置權限的門店',
  'form.permissionStore.all': '所有門店',
  'form.permissionStore.hint': '不同門店可以設置不同的權限，選擇門店後設置權限將只影響該門店',
  'stores.fetchFailed': '獲取門店列表失敗',
  'permissions.dashboard': '儀表盤',
  'permissions.members': '會員管理',
  'permissions.members.view': '查看會員',
  'permissions.members.create': '創建會員',
  'permissions.members.edit': '編輯會員',
  'permissions.members.delete': '刪除會員',
  'permissions.members.export': '導出會員',
  'permissions.cards': '禮品卡管理',
  'permissions.cards.view': '查看禮品卡',
  'permissions.cards.create': '創建禮品卡',
  'permissions.cards.edit': '編輯禮品卡',
  'permissions.cards.delete': '刪除禮品卡',
  'permissions.cards.export': '導出禮品卡',
  'permissions.vouchers': '代金券管理',
  'permissions.vouchers.view': '查看代金券',
  'permissions.vouchers.create': '創建代金券',
  'permissions.vouchers.edit': '編輯代金券',
  'permissions.vouchers.delete': '刪除代金券',
  'permissions.vouchers.export': '導出代金券',
  'permissions.selectAll': '全選',
  'permissions.hint': '選擇主模塊會自動選擇其所有子權限',
  'permissions.fetchFailed': '獲取權限數據失敗',
  'staff.title': '員工管理',
  'staff.add': '添加員工',
  'staff.search': '搜索員工',
  'staff.list.id': 'ID',
  'staff.list.username': '用戶名',
  'staff.list.email': '郵箱',
  'staff.list.role': '角色',
  'staff.list.stores': '所屬門店',
  'staff.list.noStore': '無門店',
  'staff.list.actions': '操作',
  'staff.list.fetchFailed': '獲取員工列表失敗',
  'staff.list.edit': '編輯',
  'staff.list.delete': '刪除',
  'staff.list.empty': '暫無員工數據',
  'staff.list.pagination.total': '共 {total} 條記錄',
  'staff.form.username': '用戶名',
  'staff.form.email': '郵箱',
  'staff.form.password': '密碼',
  'staff.form.role': '角色',
  'staff.form.permissionStore': '權限門店',
  'staff.form.permissionStore.placeholder': '請選擇門店',
  'staff.form.permissionStore.all': '所有門店',
  'staff.form.permissionStore.hint': '選擇要分配權限的門店',
  'staff.form.permissionStore.selected': '已選門店',
  'staff.form.permissionStore.setting': '{storeName} 權限設置',
  'staff.form.username.required': '請輸入用戶名',
  'staff.form.email.required': '請輸入郵箱',
  'staff.form.email.invalid': '郵箱格式不正確',
  'staff.form.password.required': '請輸入密碼',
  'staff.form.role.required': '請選擇角色',
  'staff.add.success': '添加員工成功',
  'staff.add.failed': '添加員工失敗',
  'staff.edit.success': '編輯員工成功',
  'staff.edit.failed': '編輯員工失敗',
  'staff.delete.confirm': '確定要刪除此員工嗎？',
  'staff.delete.content': '確定要刪除此員工嗎？該操作不可撤銷。',
  'staff.delete.success': '刪除員工成功',
  'staff.delete.failed': '刪除員工失敗',
  'staff.tabs.basic': '基本信息',
  'staff.tabs.permissions': '權限設置',
  'staff.add.title': '添加員工',
  'staff.edit.title': '編輯員工',
  'staff.permissions.fetchFailed': '獲取權限失敗',
  'staff.permissions.selectAll': '全選',
  'staff.permissions.members': '會員管理',
  'staff.permissions.members.view': '查看會員',
  'staff.permissions.members.create': '創建會員',
  'staff.permissions.members.edit': '編輯會員',
  'staff.permissions.members.delete': '刪除會員',
  'staff.permissions.members.export': '導出會員',
  'staff.permissions.cards': '禮品卡管理',
  'staff.permissions.cards.view': '查看禮品卡',
  'staff.permissions.cards.create': '創建禮品卡',
  'staff.permissions.cards.edit': '編輯禮品卡',
  'staff.permissions.cards.delete': '刪除禮品卡',
  'staff.permissions.cards.export': '導出禮品卡',
  'staff.permissions.vouchers': '優惠券管理',
  'staff.permissions.vouchers.view': '查看優惠券',
  'staff.permissions.vouchers.create': '創建優惠券',
  'staff.permissions.vouchers.edit': '編輯優惠券',
  'staff.permissions.vouchers.delete': '刪除優惠券',
  'staff.permissions.vouchers.export': '導出優惠券',
  'staff.permissions.hint': '權限將應用於選定的門店',
  'staff.permissions.clickStore': '請點擊門店標籤以設置權限',
  'staff.permissions.noStoreSelected': '請先選擇門店',
  'staff.permissions.saveFailed': '保存權限失敗',
  'staff.permissions.partialSaveError': '部分門店權限保存失敗，請稍後重試',
  'staff.permissions.emptyPermissions': '門店 {stores} 沒有設置任何權限，請至少添加一個權限',
  'staff.role.admin': '管理員',
  'staff.role.staff': '員工',
  'staff.role.manager': '店長',
  'staff.form.resetPassword': '重置密碼',
  'staff.form.resetPassword.hint': '提交後將重置該用戶密碼',
  'staff.form.newPassword': '新密碼',
  'staff.form.newPassword.required': '請輸入新密碼',
  'staff.password.reset.success': '密碼重置成功',
  'staff.password.reset.failed': '密碼重置失敗',
  'table.sort.desc': '點擊降序',
  'table.sort.asc': '點擊升序',
  'table.sort.cancel': '取消排序',
}; 